document.addEventListener('DOMContentLoaded', () => {
  const AUDIENCE_KEY = 'kiloAudience';
  const VALID_AUDIENCES = new Set(['men', 'women']);

  function getAudienceFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('audience');
  }

  function getCollectionAudience() {
    const urlAudience = getAudienceFromUrl();

    if (VALID_AUDIENCES.has(urlAudience)) {
      window.localStorage.setItem(AUDIENCE_KEY, urlAudience);
      return urlAudience;
    }

    return 'men';
  }

  function getProductAudience() {
    const urlAudience = getAudienceFromUrl();

    if (VALID_AUDIENCES.has(urlAudience)) {
      window.localStorage.setItem(AUDIENCE_KEY, urlAudience);
      return urlAudience;
    }

    const storedAudience = window.localStorage.getItem(AUDIENCE_KEY);
    if (VALID_AUDIENCES.has(storedAudience)) {
      return storedAudience;
    }

    return 'men';
  }

  function withAudience(url, audience) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set('audience', audience);

    if (nextUrl.origin === window.location.origin) {
      return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
    }

    return nextUrl.toString();
  }

  function isSmallOption(value) {
    if (!value) return false;
    const normalized = value.trim().toLowerCase();
    return normalized === 'small' || normalized === 's';
  }

  function initCollectionAudience(audience) {
    document.querySelectorAll('[data-kilo-audience-nav]').forEach((nav) => {
      nav.querySelectorAll('[data-kilo-audience-link]').forEach((link) => {
        const linkAudience = link.dataset.kiloAudienceLink;
        link.classList.toggle('is-active', linkAudience === audience);

        link.addEventListener('click', () => {
          window.localStorage.setItem(AUDIENCE_KEY, linkAudience);
        });
      });
    });

    document.querySelectorAll('[data-kilo-product-link]').forEach((link) => {
      link.href = withAudience(link.href, audience);
    });
  }

  function initProductAudience(audience) {
    if (audience !== 'women') return;

    document.querySelectorAll('[data-kilo-product]').forEach((productRoot) => {
      if (productRoot.dataset.hasSize !== 'true') return;

      const sizeIndex = productRoot.dataset.sizeIndex !== '' ? Number(productRoot.dataset.sizeIndex) : null;
      if (sizeIndex === null) return;

      const sizeInputs = Array.from(
        productRoot.querySelectorAll(`[data-kilo-option-input][data-option-index="${sizeIndex}"]`)
      );

      if (!sizeInputs.length) return;

      let smallInput = null;

      sizeInputs.forEach((input) => {
        const optionWrapper = input.closest('.kilo-product__variant-option');
        const isSmall = isSmallOption(input.value);

        if (isSmall) {
          smallInput = input;
        }

        if (optionWrapper) {
          optionWrapper.hidden = !isSmall;
        }

        input.disabled = !isSmall;
      });

      const toggleButton = productRoot.querySelector('[data-kilo-toggle="size"]');
      if (toggleButton && smallInput) {
        toggleButton.textContent = 'Select Size';
      }

      const submitButton = productRoot.querySelector('[data-kilo-submit]');

      if (!smallInput) {
        if (toggleButton) {
          toggleButton.hidden = true;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Unavailable in Women';
        }

        return;
      }

      if (!smallInput.checked) {
        smallInput.checked = true;
        smallInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  initCollectionAudience(getCollectionAudience());
  initProductAudience(getProductAudience());
});
